import * as $ from "jquery";

export class DarkOverlay {
  static readonly Selector = {
    DARK_OVERLAY: ".dark-overlay",
  };

  public static show(animationDuration = 250) {
    const { DARK_OVERLAY } = DarkOverlay.Selector;
    $(DARK_OVERLAY).fadeIn(animationDuration);
  }

  public static hide(animationDuration = 250) {
    const { DARK_OVERLAY } = DarkOverlay.Selector;
    $(DARK_OVERLAY).fadeOut(animationDuration);
  }
}
import * as $ from "jquery";

export class DarkOverlay {
  static readonly Selector = {
    DARK_OVERLAY: ".dark-overlay",
  };

  public static show(animationDuration = 250) {
    const { DARK_OVERLAY } = DarkOverlay.Selector;
    $(DARK_OVERLAY).fadeIn(animationDuration);
  }

  public static hide(animationDuration = 250) {
    const { DARK_OVERLAY } = DarkOverlay.Selector;
    $(DARK_OVERLAY).fadeOut(animationDuration);
  }
}
